import {
  useGetParentshipTypeListQuery,
  useGetCountriesQuery,
  useGetCitizenshipListQuery,
  useGetGenderListQuery,
  useGetNationalityListQuery,
} from "../../../../queries/codeBookQuery";

export const useParentCodebooks = () => {
  const { data: parentshipTypes } = useGetParentshipTypeListQuery();
  const { data: countries } = useGetCountriesQuery();
  const { data: citizenships } = useGetCitizenshipListQuery();
  const { data: genders } = useGetGenderListQuery();
  const { data: nationalities } = useGetNationalityListQuery();

  const getCodebookName = (
    list: any[] | undefined,
    id: number | null | undefined
  ) => list?.find((x) => x.id === id)?.name || "";

  return {
    parentshipTypes,
    countries,
    citizenships,
    genders,
    getCodebookName,
    nationalities,
  };
};
